import Superadmins from "./Superadmins";

export default Superadmins;